import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { TenantHostService } from '@core/services/tenant-host.service';
import { TenantScopeService } from '@core/services/tenant-scope.service';

import { IconComponent } from '@shared/components/icon/icon.component';

/**
 * Dark strip above the storefront header identifying a branded tenant
 * storefront, with a way back to the shared marketplace (HLD SM-02/SM-03).
 */
@Component({
  selector: 'app-tenant-band',
  standalone: true,
  imports: [RouterLink, IconComponent],
  templateUrl: './tenant-band.component.html',
  styleUrl: './tenant-band.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TenantBandComponent {
  protected readonly tenantScope = inject(TenantScopeService);
  /** Supplies the real base domain, so the band never names a domain we do not serve. */
  protected readonly tenantHost = inject(TenantHostService);
}
